import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MDIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MD" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#D9071E"
        fillRule="evenodd"
        d="M10.4 0H16v12h-5.6V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0h5.6v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FBCD17"
        fillRule="evenodd"
        d="M4.8 0h6.4v12H4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FD1900"
        d="m7.528 6.977-1.745 3.194-.526-.287L7.002 6.69l.526.287Zm3.331 2.83-.526.288-1.745-3.194.526-.288 1.745 3.194Z"
      />
      <Path
        fill="#A77B3B"
        d="M8.17 8.047c.01.025.415 1.055 1.58 1.869-1.257.335-1.58 1.01-1.58 1.01 0-.54-1.595-1.01-1.595-1.01.541-.353 1.332-1.93 1.332-1.93l.263.06Zm-.11-6.621c.828 0 .924.39.924.702 0 .311-.476.983-.476 1.24s.194.753.476.754c.199 0 1.154-.374 1.706-.596v-.822c.134-.982.784-1.122.8-1.125 0 0 .799.287.8 1.125v7.47s-.533-.686-.8-.985c-.268-.299-.8-1.102-.8-1.719V4.695h-5V7.47c0 .617-.532 1.42-.8 1.72-.267.298-.8.984-.8.984v-7.47c.001-.838.8-1.125.8-1.125.015.003.666.142.8 1.125v1.305l.082-.272c.27.198.858.571 1.252.385.521-.247.705-.948.708-.962 0 0-.05-.72-.265-.72-.216-.001-.233-1.014.594-1.014Zm-1.572 6.24c.365 0 .66.28.66.626 0 .345-.295.625-.66.625-.364 0-.66-.28-.66-.625s.296-.625.66-.625Zm3.212 0c.365 0 .66.28.66.626 0 .345-.295.625-.66.625-.364 0-.66-.28-.66-.625s.296-.625.66-.625Z"
      />
      <Path
        fill="#FDFF00"
        d="m12.57 5.204.46.198-1.87 4.326-.46-.198 1.87-4.326Z"
      />
      <Path
        fill="#E1E5E8"
        fillRule="evenodd"
        d="M5.52 3.917h5.28v3.82s-1.344.404-2.64 1.068c-.957-.71-2.64-1.069-2.64-1.069v-3.82Z"
        clipRule="evenodd"
        opacity={0.3}
      />
      <Mask
        id="b"
        width={6}
        height={6}
        x={5}
        y={3}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M5.52 3.917h5.28v3.82s-1.344.404-2.64 1.068c-.957-.71-2.64-1.069-2.64-1.069v-3.82Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path fill="#3D58DB" d="M5.52 6.417h5.28v2.5H5.52z" />
        <Path fill="#FD1900" d="M5.52 3.917h5.28v2.5H5.52z" />
        <Path
          fill="#FDFF00"
          fillRule="evenodd"
          d="m7.893 5.041-.4.033.231-.311-.246-.323.402.052.154-.355.172.363.4-.033-.23.311.245.322-.402-.051-.154.355-.172-.363Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FDFF00"
          fillRule="evenodd"
          d="M7.175 4.336S6.1 4.99 6.458 5.459c.359.47.81.53.81.53s-1.1 1.65.835 2.592c2.072-.91.983-2.592.983-2.592s.638-.141.765-.649c.128-.507-.833-1.09-.833-1.09s.6.87.462 1.09c-.136.22-.87.445-1.377.445-.506 0-1.288-.142-1.415-.527-.126-.385.487-.922.487-.922Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FDFF00"
          fillRule="evenodd"
          d="m6.18 6 .66.417-.66.416-.66-.416L6.18 6ZM10.14 6l.66.417-.66.416-.66-.416.66-.417ZM6.16 7.65a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4ZM10.415 7.271c-.172-.139-.435-.098-.588.09-.153.19-.137.455.034.594.094.076.045-.224.186-.415.119-.16.446-.205.368-.269Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#048F02"
        d="M4.779 7.077c0 .008.106.76-.325.917-.432.158-1.075-.402-1.075-.402h.454v-.174l.25.174v-.174h.32l.376-.341Zm-.655-.87c.003.022.102.76-.324.917-.429.157-1.063-.391-1.075-.402h.453V6.55l.25.173V6.55h.32l.376-.341Zm-.356-.957c0 .004.119.731-.376.934-.496.204-1.024-.42-1.024-.42h.454v-.173l.25.173v-.173h.32l.376-.341Z"
      />
      <Path
        fill="#FDFF00"
        d="M6.99 1.422h.286v.5H6.99v.872h-.5v-.872h-.236v-.5h.236v-.298h.5v.298Z"
      />
      <Path
        fill="#DB4400"
        fillRule="evenodd"
        d="m7.58 1.692-1.159.299 1.158.366v-.665Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
